import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { SellAreaCodeComboBoxModel } from '../sell-area-code-combo-box.model';
import { SellArea } from '../sell-area.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 売り場コードリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetSellAreaCodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSellAreaCodeListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: SellAreaCodeComboBoxModel;
  private mediumType: string = null;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSellAreaCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {SellAreaCodeComboBoxModel} model
   * @param {string} mediumType
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetSellAreaCodeListService
   */
  execute(model: SellAreaCodeComboBoxModel, mediumType: string, successFunc: () => void = null) {
    this.model = model;
    this.mediumType = mediumType;
    this.successFunc = successFunc;
    this.send('KYMW02getSellingAreaList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSellAreaCodeListService
   */
  success(data: any) {
    this.model.updateDataList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
